import React, { Fragment, useState, useMemo, useContext } from 'react';
import T from 'prop-types';
import { pick } from 'lodash-es';

import Slide from './Slide';
import EditingMarketApps from './EditingMarketApps';
import EditingMarketModal from './modals/EditingMarketModal';
import UserReportFormModal from './modals/UserReportFormModal';
import Button from '../../../../../components/Buttons/Button';
import useMobileView from '../../shared/hooks/useMobileView';
import { InitialDataContext } from '../context';

import Carousel3D from '../../../../../components/Carousel3D';

const ReportPreview = ({
  errors,
  isProcessing,
  selectedApps,
  reportCharts,
  setProcessing,
  onAppsChange,
  onChartsChange,
  onSubmit,
}) => {
  const isMobileView = useMobileView();
  const { popularApps, sitekey } = useContext(InitialDataContext);

  const [isEditMode, setEditMode] = useState(false);
  const [isUserFormModalOpen, setUserFormModalOpen] = useState(false);

  const customErrors = useMemo(() =>
    pick(errors, ['firstName', 'lastName', 'email', 'jobFunction']),
  [errors]);

  return (
    <Fragment>
      <div className="report-preview">
        <h3 className="report-preview-main-header">Your Market at a Glance</h3>
        <Carousel3D
          focusOnLoad
          slides={[0, 1, 2, 3, 4].map(slide => (
            <Slide
              key={slide}
              id={slide}
              selectedApps={selectedApps}
              reportCharts={reportCharts}
              setUserFormModalOpen={setUserFormModalOpen}
              setEditMode={setEditMode}
            />
          ))}
        />
        <Button
          size="lg"
          className="main-get-button"
          onClick={() => setUserFormModalOpen(true)}
        >
          Get the Full Report
        </Button>
      </div>

      {isMobileView && isEditMode && (
        <EditingMarketApps
          selectedApps={selectedApps}
          popularApps={popularApps}
          withChartsRequest
          onClose={setEditMode}
          onChange={onAppsChange}
          onChartsChange={onChartsChange}
        />
      )}

      <EditingMarketModal
        show={!isMobileView && isEditMode}
        selectedApps={selectedApps}
        popularApps={popularApps}
        withChartsRequest
        onHide={setEditMode}
        onAppsChange={onAppsChange}
        onChartsChange={onChartsChange}
      />

      <UserReportFormModal
        show={isUserFormModalOpen}
        sitekey={sitekey}
        isProcessing={isProcessing}
        customErrors={customErrors}
        setProcessing={setProcessing}
        onSubmit={onSubmit}
        onHide={setUserFormModalOpen}
      />
    </Fragment>
  );
};

ReportPreview.propTypes = {
  errors: T.object.isRequired,
  isProcessing: T.bool.isRequired,
  selectedApps: T.array.isRequired,
  reportCharts: T.object.isRequired,
  setProcessing: T.func.isRequired,
  onAppsChange: T.func.isRequired,
  onChartsChange: T.func.isRequired,
  onSubmit: T.func.isRequired,
};

export default ReportPreview;
